module.exports = __webpack_public_path__ + "img/logo-6.6b6606c3.png";